import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyPdfWorkerEs5WorkaroundIfNeeded } from './pdf-es5-detection';

if (environment.production) {
  enableProdMode();
}

// Must run before any <ngx-extended-pdf-viewer> resolves its worker URL.
applyPdfWorkerEs5WorkaroundIfNeeded();

platformBrowserDynamic().bootstrapModule(AppModule);
